angular.module('tgaAdmin').controller('LeaderboardController', [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  'gameService',
  'playerService',
  'statsService',
  'modalService',
  'reportService',
  'settingsService',
  function (
    $scope,
    $rootScope,
    $state,
    $timeout,
    gameService,
    playerService,
    statsService,
    modalService,
    reportService,
    settingsService,
  ) {
    $scope.showBack = false;
    $scope.root = $rootScope;

    $scope.data = {
      alerts: [],
      filedate: moment().format('YYYY-MM-DD HH-mm-ss'),
      separator: ',',
      decimalSeparator: '.',
      game_id: parseInt($state.params.game_id, 10) || null,
      datePickerOptions: settingsService.getDatePickerOptions(
        {},
        {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day') ||
              !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.$broadcast('updatedDatepickerRange');
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      ),
    };

    $scope.viewmodel = {
      game: {},
      range: 'All Time',
      oldRange: {
        startDate: null,
        endDate: null,
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
      players: [],
      playersHidden: [],
      playersGrouped: [],
      isRefreshing: false,
      showHidden: false,
      customFieldGrouping: null,
    };

    $scope.initialize = function () {
      gameService.getGame($scope.data.game_id).then((game) => {
        $scope.viewmodel.game = game;
        $scope.data.datePickerOptions.ranges['All Time'] = [moment(game.date_created).startOf('month'), moment()];
        $scope.viewmodel.dateRange.startDate = $scope.viewmodel.oldRange.startDate = moment(game.date_created).startOf(
          'month',
        );
        $scope.viewmodel.dateRange.endDate = $scope.viewmodel.oldRange.endDate = moment();

        $scope.title = `<span class="text-muted">Leaderboard /</span> <span class="text-capitalize">${$scope.viewmodel.game.name}</span>`;

        // Grouping
        $scope.viewmodel.required_fields = [];
        $scope.viewmodel.custom_fields = [];

        if ($scope.viewmodel.game.registration.required) {
          for (let i = 0; i < $scope.viewmodel.game.registration.fields.length; i++) {
            if (
              $scope.viewmodel.game.registration.fields[i].condition === 'required' ||
              $scope.viewmodel.game.registration.fields[i].condition === 'optional'
            ) {
              const requiredField = $scope.viewmodel.game.registration.fields[i];
              $scope.viewmodel.required_fields.push(requiredField);
            }
          }

          for (let i = 0; i < $scope.viewmodel.game.registration.custom_fields.length; i++) {
            if (
              $scope.viewmodel.game.registration.custom_fields[i].type === 'dropdown' &&
              // eslint-disable-next-line max-len
              ($scope.viewmodel.game.registration.custom_fields[i].condition === 'required' ||
                $scope.viewmodel.game.registration.custom_fields[i].condition === 'optional')
            ) {
              const customField = $scope.viewmodel.game.registration.custom_fields[i];
              $scope.viewmodel.custom_fields.push(customField);
            }
          }
        }
      });
    };

    $scope.actions = {
      loadLeaderboards() {
        $scope.$broadcast('updatedDatepickerRange');
      },
      loadLeaderboard(tableState) {
        $scope.loading = true;
        if (tableState) $scope.currTableState = tableState;
        // if live refresh is activated always set end date to current time
        if ($scope.viewmodel.isRefreshing) $scope.viewmodel.dateRange.endDate = new Date();
        const params = tableState
          ? {
              game_id: $scope.data.game_id,
              best: 'highest',
              paginate: true,
              start_date: $scope.viewmodel.dateRange.startDate?.toISOString(true),
              end_date: $scope.viewmodel.dateRange.endDate?.toISOString(true),
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
            }
          : {
              game_id: $scope.data.game_id,
              best: 'highest',
              paginate: true,
              page: 1,
            };

        if (tableState?.search?.predicateObject) {
          Object.keys(tableState.search.predicateObject).forEach((key) => {
            // Check for divisions first and set values to a divisions array
            if (key === 'divisions') {
              params['divisions[]'] = Object.keys(tableState.search.predicateObject.divisions).map(
                (divisionKey) => tableState.search.predicateObject.divisions[divisionKey].value,
              );
            } else {
              params[key] = tableState.search.predicateObject[key];
            }
          });
        }
        statsService.getLeaderboard(params).then((response) => {
          $scope.viewmodel.players = response.items || response;

          if (!tableState) {
            tableState = $scope.currTableState;
            tableState.pagination.start = 0;
          }

          tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
          tableState.pagination.totalItemCount = response.total;

          $scope.loading = false;

          if ($scope.viewmodel.customFieldGrouping) {
            $scope.actions.buildGroupedData();
          }
        });
      },
      loadHiddenLeaderboard(tableState) {
        $scope.loading = true;
        if (tableState) $scope.currHiddenTableState = tableState;

        $scope.viewmodel.playersHidden = [];

        const params = tableState
          ? {
              game_id: $scope.data.game_id,
              best: 'highest',
              paginate: true,
              start_date: $scope.viewmodel.dateRange.startDate?.toISOString(true),
              end_date: $scope.viewmodel.dateRange.endDate?.toISOString(true),
              page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
              limit: tableState.pagination.number,
              sort: tableState.sort.predicate,
              order: tableState.sort.reverse ? 'desc' : 'asc',
              hidden: true,
            }
          : {
              game_id: $scope.data.game_id,
              best: 'highest',
              paginate: true,
              page: 1,
              hidden: true,
            };

        statsService.getLeaderboard(params).then((response) => {
          $scope.viewmodel.playersHidden = response.items || response;

          if (!tableState) {
            tableState = $scope.currHiddenTableState;
            tableState.pagination.start = 0;
          }

          tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
          tableState.pagination.totalItemCount = response.total;
          $scope.loading = false;
        });
      },
      exportPlayerStats() {
        const reportData = [];
        const headers = ['Rank', 'Player', 'Score'];

        reportData.push([`${$scope.viewmodel.game.name} Leaderboard`]);

        if ($scope.viewmodel.game.registration.required === true) {
          for (let i = 0; i < $scope.viewmodel.required_fields.length; i++) {
            headers.push($scope.viewmodel.required_fields[i].label);
          }

          for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
            headers.push($scope.viewmodel.custom_fields[i].label);
          }
        }

        reportData.push(headers);

        const params = {
          game_id: $scope.data.game_id,
          best: 'highest',
          limit: 1000,
          paginate: false,
          start_date: $scope.viewmodel.dateRange.startDate,
          end_date: $scope.viewmodel.dateRange.endDate,
        };

        return statsService.getLeaderboard(params).then((response) => {
          const players = response.items || response;
          for (let j = 0; j < players.length; j++) {
            const data = [players[j].rank, players[j].display_name, players[j].points];

            if ($scope.viewmodel.game.registration.required === true) {
              for (let i = 0; i < $scope.viewmodel.required_fields.length; i++) {
                if ($scope.viewmodel.required_fields[i].condition !== null) {
                  data.push(players[j][$scope.viewmodel.required_fields[i].key]);
                }
              }

              for (let i = 0; i < $scope.viewmodel.custom_fields.length; i++) {
                if (
                  players[j].custom_fields &&
                  players[j].custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`]
                ) {
                  // eslint-disable-next-line max-len
                  data.push(
                    players[j].custom_fields[`custom_field_${$scope.viewmodel.custom_fields[i].custom_field_id}`].text,
                  );
                } else {
                  data.push(null);
                }
              }
            }

            reportData.push(data);
          }
          return reportData;
        });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      toggleHidden() {
        $scope.viewmodel.showHidden = !$scope.viewmodel.showHidden;
        $scope.viewmodel.playersHidden = [];
      },
      // all players
      submitHideEntry(entry, hidden) {
        const data = [];

        if (angular.isArray(entry)) {
          entry.forEach((item) => {
            item.hidden = hidden;
            data.push(item);
          });
        } else {
          data.push({ session_id: entry.session_id, hidden });
        }

        $scope.windowLoader = true;

        // instead of passing in sessions data, on the BE i should just send all param and it does it there
        playerService.hideSessionEntry({ sessions: data }).then(() => {
          $scope.$broadcast('updatedDatepickerRange');
          $scope.windowLoader = false;
        });
      },
      showScoreConfirm(player) {
        const isArray = angular.isArray(player);
        const message = isArray ? 'all hidden entries' : 'this entry';
        const btn = isArray ? 'Restore Entries' : 'Restore Entry';

        modalService
          .showModal(
            {
              title: isArray ? 'Restore Entries?' : 'Restore Entry?',
              message: `Are you sure you want to move ${message} back to the leaderboard?`,
              closeButton: 'Cancel',
              actionButton: btn,
              actionClass: 'danger',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(() => {
            $scope.actions.submitHideEntry(player, false);
            if (isArray) {
              $scope.actions.toggleHidden();
            }
          })
          .catch(angular.noop);
      },
      hideScoreConfirm(player) {
        const isArray = angular.isArray(player);
        const message = isArray ? 'all entries' : 'this entry';
        const btn = isArray ? 'Hide Entries' : 'Hide Entry';

        modalService
          .showModal(
            {
              title: isArray ? 'Hide Entries?' : 'Hide Entry?',
              message: `Are you sure you want to hide ${message} from the leaderboard?`,
              closeButton: 'Cancel',
              actionButton: btn,
              actionClass: 'danger',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(() => {
            $scope.actions.submitHideEntry(player, true);
          })
          .catch(angular.noop);
      },
      toggleLiveRefresh() {
        $scope.viewmodel.isRefreshing = !$scope.viewmodel.isRefreshing;

        if ($scope.viewmodel.isRefreshing) {
          $scope.actions.liveRefresh();
        } else {
          $timeout.cancel($scope.refreshTimer);
        }
      },
      liveRefresh() {
        $scope.$broadcast('updatedDatepickerRange');

        $scope.refreshTimer = $timeout(() => {
          $scope.actions.liveRefresh();
        }, 10000);
      },
      toggleFullScreenMode() {
        $rootScope.fullscreen = !$rootScope.fullscreen;
      },
      buildGroupedData() {
        const results = [];
        const customFieldKey = $scope.viewmodel.customFieldGrouping;

        if (!customFieldKey) {
          return;
        }

        $scope.viewmodel.playersGrouped = [];
        $scope.loading = true;

        const params = {
          game_id: $scope.data.game_id,
          best: 'highest',
          start_date: $scope.viewmodel.dateRange.startDate?.toISOString(true),
          end_date: $scope.viewmodel.dateRange.endDate?.toISOString(true),
          paginate: true,
          limit: 1000,
          page: 1,
        };

        statsService.getLeaderboard(params).then((response) => {
          const players = response.items || response;

          $scope.loading = false;

          const groups = {}; // each group.key = { data: {}, items: [] }

          for (let i = 0; i < players.length; i++) {
            const field = players[i].custom_fields[customFieldKey];

            if (field) {
              $scope.viewmodel.groupedBy = field.name;
              const option_id = field.text;

              if (!Object.keys(groups).includes(option_id)) {
                groups[option_id] = {
                  option_id: field.custom_field_option_id,
                  display_name: field.text,
                  pointTotal: 0,
                  highestScore: 0,
                  items: [],
                };
              }

              groups[option_id].items.push(players[i]);
              groups[option_id].pointTotal += players[i].points;
              groups[option_id].highestScore =
                players[i].points > groups[option_id].highestScore ? players[i].points : groups[option_id].highestScore;
            }
          }

          Object.keys(groups).forEach((key) => {
            groups[key].points = Math.round(groups[key].pointTotal / groups[key].items.length);
            results.push({
              key: groups[key].option_id,
              display_name: groups[key].display_name,
              points: groups[key].points,
              total: groups[key].pointTotal,
              highest: groups[key].highestScore,
              rank: null,
              items: groups[key].items,
            });
          });

          // Sort high to low
          results.sort((a, b) => b.points - a.points);

          // Rank
          let rank = 1;

          for (let i = 0; i < results.length; i++) {
            if (i > 0 && results[i].points < results[i - 1].points) {
              rank++;
            }

            results[i].rank = rank;
          }

          $scope.viewmodel.playersGrouped = results;
        });
      },
      generateReportFilename: reportService.generateReportFilename,
    };

    $scope.initialize();

    $scope.$on('updatedDatepickerRange', () => {
      if ($scope.viewmodel.customFieldGrouping) {
        $scope.actions.buildGroupedData();
      }
    });

    $scope.$on('$destroy', () => {
      $timeout.cancel($scope.refreshTimer);
      $rootScope.fullscreen = false;
    });
  },
]);
